import React, { useState } from "react";

import "./Profile.css";
import useIsMobile from "../shared/hooks/IsMobileHook";

const navLinks = [
  { name: "Intro" },
  { name: "Resume" },
  { name: "Projects" },
  { name: "Graphics" },
  { name: "GitHub" },
];

const Profile: React.FC = () => {
  const [page, setPage] = useState("Intro");
  const isMobile = useIsMobile();
  const navPanel = () => {
    return (
      <nav className={isMobile ? "profile-nav-mobile" : "profile-nav"}>
        {!isMobile && (
          <h2 style={{ marginBottom: "2rem", fontSize: "1.5rem" }}>
            Portfolio
          </h2>
        )}
        {navLinks.map((link) => (
          <button
            className={
              isMobile ? "profile-nav-button-mobile" : "profile-nav-button"
            }
            key={link.name}
            onClick={() => {
              if (link.name === "GitHub") {
                window.open("https://github.com/brigb123", "_blank");
              } else {
                setPage(link.name);
              }
            }}
          >
            {link.name}
          </button>
        ))}
      </nav>
    );
  };
  return (
    <div
      style={{ display: "flex", minHeight: "100vh", fontFamily: "sans-serif" }}
    >
      {!isMobile && navPanel()}
      {/* Main Content */}
      <main
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {isMobile && navPanel()}
        <div className="profile-content">
          {page === "Intro" && (
            <div className="profile-intro">
              <img
                src="/BrigBagley.jpg"
                alt="Profile"
                style={{
                  borderRadius: "50%",
                  margin: "1rem",
                  border: "4px solid #888",
                  width: "150px",
                }}
              />
              <h1 style={{ marginBottom: "1rem" }}>Brig Bagley</h1>
              <h3 style={{ marginBottom: "1rem" }}>Senior Software Engineer</h3>
              <p
                style={{ maxWidth: "700px", textAlign: "left", color: "#aaa" }}
              >
                I have a broad and diverse background in software development,
                with experience spanning biology, geophysical data, robotics,
                and golf technology. Throughout my career, I have professionally
                applied concepts from artificial intelligence, computer
                graphics, machine learning, and image processing. Proficient in
                multiple programming languages, platforms, and development
                tools, I specialize in researching and developing software
                solutions for complex challenges using scientific algorithms and
                mathematical principles.
              </p>
              <p
                style={{ maxWidth: "700px", textAlign: "left", color: "#aaa" }}
              >
                I enjoy and flourish in visually stimulating projects. While
                much of my work has focused on low-level software development, I
                am eager to return to my graphics roots with front-end
                technologies, particularly WebGL, web applications and React. I
                work well within a team and on my own. I prioritize
                organization, aim for efficiency, and often exceed expectations.
              </p>
            </div>
          )}
          {page === "Projects" && (
            <div
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%", // 16:9 aspect ratio
              }}
            >
              <iframe
                src={
                  "https://docs.google.com/presentation/d/e/" +
                  "2PACX-1vTFjCjscX7Pm3hFsKVa_JaHqHqJVKlHhv-K4robTAAs5lkhl4pFquV_" +
                  "YsbZm34RBwxEJoJdfJbe63KZ/pubembed?start=false&loop=false&delayms=3000"
                }
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                allowFullScreen
                title="Projects Presentation"
              ></iframe>
            </div>
          )}
          {page === "Resume" && (
            <iframe
              src="/BrigBagley-ResumePublic.pdf"
              title="Resume PDF"
              width="100%"
              height="100%"
              style={{ border: "none", flex: 1 }}
            />
          )}
          {page === "Graphics" && (
            <iframe
              src="https://users.csc.calpoly.edu/~zwood/teaching/csc473/finals11/bbagley/"
              title="Graphics Projects"
              width="100%"
              height="100%"
              style={{ border: "none", flex: 1 }}
            />
          )}
        </div>
        {/* Footer */}
        <div className="profile-footer">
          Copyright © 2023 GameNightTV. All rights reserved.
        </div>
      </main>
    </div>
  );
};

export default Profile;
